import { useQuery } from 'react-query';
import { FetchedOrganizationPackagesData } from '../types';
import { getOrganizationPackagesData } from '../api';

export const ORGANIZATION_PACKAGES_QUERY_KEY = 'ORGANIZATION_PACKAGES_QUERY';

export const useOrganizationPackagesData = (autofetch = true) => {
    const userOrganizationPackageDataQuery = useQuery({
        queryKey: [ORGANIZATION_PACKAGES_QUERY_KEY],
        queryFn: async (): Promise<FetchedOrganizationPackagesData> => getOrganizationPackagesData(),
        enabled: autofetch,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: Infinity,
    });

    const fetchedData = userOrganizationPackageDataQuery?.data;

    return {
        isPackagesDataLoading: userOrganizationPackageDataQuery?.isLoading,
        legalDocumentsPackageData: fetchedData?.legalDocsPackageData,
        refetchPackagesData: () => userOrganizationPackageDataQuery.refetch({ stale: true }),
    };
};
